<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="item in 2" :key="item">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4">Configurações do Firewall</div>
      <v-row align="baseline" dense>
        <v-col cols="3">
          <v-switch dense class="ml-2" v-model="formConfig.firewall" label="Ativar Firewall?" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            dense
            :value="portasABloquear"
            @change="v => (portasABloquear = v)"
            label="Portas a Bloquear"
            outlined
            hint="Ex.: 7000,7001,7002-7005"
            persistent-hint
          />
        </v-col>
      </v-row>

      <v-divider class="ma-2" />

      <v-row>
        <v-col>
          <div class="text-h5 mb-n4">IPs Bloqueados</div>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col>
          <v-btn color="orangePcm" dark @click="deleteAll"
            >Desbloquear Todos</v-btn
          >
          <v-btn class="ml-2" color="orangePcm" dark @click="deleteSelected"
            >Desbloquear Selecionados</v-btn
          >
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Busca"
            class="mr-4 mb-4"
          />
        </v-col>
      </v-row>
      <v-data-iterator
        :items="dataIpsBloqueados"
        :no-data-text="noDataText"
        hide-default-footer
        :search="search"
        :no-results-text="noResultsText"
        :items-per-page.sync="itemsPerPage"
        :page="page"
      >
        <template v-slot:default="props">
          <v-data-table
            dense
            :headers="headers"
            :items="props.items"
            hide-default-footer
            class="elevation-1"
            disable-pagination
            disable-sort
            show-select
            v-model="arrayIPsSelecionados"
            item-key="_id"
          >
            <template v-slot:[`item.botoes`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </template>

        <template v-slot:footer>
          <v-row class="mt-2" align="center">
            <div class="ml-4 mb-1 grey--text">
              <div class="text-subtitle-1 text-left">
                Total de IPs: {{ dataIpsBloqueados.length }}
              </div>
            </div>
            <v-spacer />
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </v-row>
        </template>
      </v-data-iterator>

      <div v-for="n in 3" :key="n">
        <v-divider vertical />
      </div>
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'
import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'

import firewallStore from '../_store'
import firewallHttpService from '../_services/firewallHttpService'

export default {
  name: 'CadastroAudio',
  components: { Snackbar, FixedButtons, ListPagination },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    hideButtons: false,
    pararLoader: {
      parar: false,
    },
    page: 1,
    loader: false,
    text: '',
    snackbar: false,
    showSkeleton: true,
    portasABloquear: '',
    itemsPerPage: 20,
    search: '',
    headers: [
      {
        text: 'IP',
        value: 'ip',
        align: 'start',
      },
      {
        text: 'Data Bloqueio',
        value: 'createdAt',
        align: 'left',
      },
      {
        text: 'Deletar',
        value: 'botoes',
        align: 'center',
      },
    ],
    formConfig: {
      firewall: true,
      firewallPorts: [],
      firewallPortsVisual: '',
    },
    dataIpsBloqueados: [],
    arrayIPsSelecionados: [],
  }),

  computed: {
    ...mapGetters('firewallConfigHomeModulePABXStore', ['getFirewallConfig', 'getIpsBlocked']),
    numberOfPages() {
      return Math.ceil(this.dataIpsBloqueados.length / this.itemsPerPage)
    },
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'firewallConfigHomeModulePABXStore', firewallStore)

    await Promise.all([this.listarConfiguracoesFirewall(), this.listarIpsBloqueados()])

    this.formConfig.firewall = this.getFirewallConfig.firewall
    this.formConfig.firewallPorts = this.getFirewallConfig.firewallPorts
    this.formConfig.firewallPortsVisual = this.getFirewallConfig.firewallPortsVisual

    this.portasABloquear = this.getFirewallConfig.firewallPortsVisual
    this.dataIpsBloqueados = this.getIpsBlocked.map(ipBlock => ({
      ...ipBlock,
      createdAt: moment(ipBlock.createdAt, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'),
    }))

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('firewallConfigHomeModulePABXStore', ['listarConfiguracoesFirewall', 'listarIpsBloqueados']),
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) {
        this.page += 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    formerPage() {
      if (this.page - 1 >= 1) {
        this.page -= 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    firstPage() {
      if (this.page > 1) {
        this.page = 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    lastPage() {
      if (this.page < this.numberOfPages) {
        this.page = this.numberOfPages
        this.$router.push({ query: { page: this.page } })
      }
    },

    portasABloquearFormer(numero) {
      const numeroIntermediario = numero.split(',')
      const numeroArray = []

      numeroIntermediario.forEach(numeros => {
        if (typeof numeros.split('-')[1] === 'undefined') {
          numeroArray.push(numeros)
        } else {
          const inicioRange = numeros.split('-')[0]
          const finalRange = numeros.split('-')[1]
          if (inicioRange > finalRange) {
            window.alert('Início do range não pode ser maior que final do range')
            return
          } else {
            for (let i = inicioRange; i <= finalRange; i++) {
              numeroArray.push(i.toString())
            }
          }
        }
      })
      return numeroArray
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o IP "${item.ip}"?`)
      if (resultado) {
        try {
          await firewallHttpService.deleteOneIp(item._id)
          let index = this.dataIpsBloqueados.findIndex(x => x._id === item._id)
          this.dataIpsBloqueados.splice(index, 1)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },

    async deleteAll() {
      let resultado = window.confirm(`Deseja remover todos os IPs?`)
      if (resultado) {
        try {
          await firewallHttpService.deleteAllIps()
          this.dataIpsBloqueados.splice(0)
        } catch (error) {
          console.log(error)
          alert(error)
        }
      }
    },

    async deleteSelected() {
      const idIPsSelecionados = { toDelete: this.arrayIPsSelecionados.map(ip => ip._id) }

      let resultado = window.confirm(`Deseja remover os IPs selecionados?`)
      if (resultado) {
        try {
          await firewallHttpService.deleteSelectedIps(idIPsSelecionados)
          idIPsSelecionados.toDelete.forEach(item => {
            const index = this.dataIpsBloqueados.findIndex(x => x._id === item)
            this.dataIpsBloqueados.splice(index, 1)
          })
        } catch (e) {
          alert(e.message)
        }
      }
    },

    async salvar() {
      this.pararLoader.parar = false
      try {
        await firewallHttpService.putFirewallConfig(this.formConfig)
        this.$router.push({ name: 'pabx' })
      } catch (error) {
        console.log(error.response)
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'pabx' })
    },
  },
  watch: {
    portasABloquear(novo) {
      this.formConfig.firewallPorts = this.portasABloquearFormer(novo)
      this.formConfig.firewallPortsVisual = novo
      if (this.formConfig.firewallPorts[0] === '' && this.formConfig.firewallPorts.length === 1)
        this.formConfig.firewallPorts.splice(0, 1)
    },
  },
}
</script>
